import { render, staticRenderFns } from "./testSysRole.vue?vue&type=template&id=20652d2e&scoped=true"
import script from "./testSysRole.vue?vue&type=script&lang=js"
export * from "./testSysRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20652d2e",
  null
  
)

export default component.exports